define('common/ko/fn/pipe',['knockout'], function(ko) {

    /**
     * Use this to transform the value of a subscribable in a fluent chain.
     *
     * Differs from "map" as it won't traverse an array.
     *
     * @param {Object} [isArray] - Pass the Array constructor to indicate this is an array
     * @param {Function} pipeFn
     */
    ko.subscribable.fn.pipe = function(arg1, arg2) {

        var isArray = arg1 === Array,
            pipeFn = arg1,
            subject = this,
            factory = ko.pureComputed;

        if (isArray) {
            pipeFn = arg2;
            factory = ko.pureComputedArray;
        }

        return factory(function() {
            return pipeFn(subject());
        });
    };

});

